module.exports = __webpack_public_path__ + "static/media/winterkoalefanttrunk.90884411.webp";